import custom from './custom'
import common from './common'

const pageRouters = [
  custom,
  ...common
]

export default pageRouters
